module.exports = __webpack_public_path__ + "static/img/yzs.5262add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yzs.jpg
// module id = AYgN
// module chunks = 1